

























































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { UserSearchResultModel } from "@/admin/types";
import Users from "@/admin/components/shared/Users.vue";
import { AdminFinicityLinkedAccountsUsers } from "@/admin/route-names";
import { AdminFinicityLinkedAccountsTitle } from "@/admin/constants";
import { useUtilityStore } from "@/admin/store/utility";
import { useUserSearchStore } from "@/admin/store/userSearch";

@Component({
  components: {
    Button,
    Input,
    ErrorSummary,
    GenericLoadingSpinner,
    Users
  }
})
export default class AdminFinicityLinkedAccounts extends Vue {
  $validator: Validator;

  utilityStore = useUtilityStore();
  userSearchStore = useUserSearchStore();

  @Prop()
  userId: string;

  user: UserSearchResultModel = null;
  AdminFinicityLinkedAccountsTitle = AdminFinicityLinkedAccountsTitle;

  mounted () {
    this.userSearchStore.loadUser(this.userId as any)
      .then(user => {
        this.user = user;
        this.utilityStore.loadFinicityLinkedAccounts(user.cognitoUsername);
      });
  }

  get isLoaded () {
    return this.user && this.utilityStore.isFinicityAccountDetailsLoaded;
  }

  get areRecords () {
    return this.utilityStore.finicityAccountDetails.length !== 0;
  }

  onReset () {
    this.$router.push({ name: AdminFinicityLinkedAccountsUsers });
    this.userSearchStore.reset();
  }
}

